module.exports = __webpack_public_path__ + "img/2.310fe01e.png";